<h2 mat-dialog-title>{{ data.title }}</h2>
<div *ngIf="hasWarning()">
  <p class="warning">
    {{ data.warning }}
  </p>
</div>
<h3>Design Organisation's Declaration</h3>
<p class="declaration">
  We confirm on behalf of <span class="declaration-input">[Design Organisation - to be defined below]</span> that this
  application for a Departure from Standards has been assessed and that:<br /><br />

  In our professional view, the proposed Departure from Standard is fully justified in of the above-mentioned
  assessment;<br /><br />

  The residual risks are so far as is reasonably practicable (SFAIRP) and the design with the departure has a net
  benefit when compared to a fully compliant design;<br /><br />

  On the basis of the above, we recommend approval of the attached application for a Departure from Standard;<br /><br />

  We confirm that we have used reasonable professional skill and care in the preparation of the design (encompassing the
  Departure from Standard);<br /><br />

  We confirm our understanding that approval of this application, if granted, is on the basis that the safety risk
  treatments and control measures listed in the application are to be incorporated into the design.<br /><br />

  Designer's Name: <span class="declaration-input">[Designer's Name - to be defined below]</span><br /><br />
  Job Title: <span class="declaration-input">[Job Title - to be defined below]</span><br /><br />
  Date: {{ todayDate }}<br /><br />
</p>
<mat-dialog-content>
  <das-user-autocomplete
    *ngFor="let assignment of data.assignableRoles"
    [users]="assignment.users"
    [role]="assignment.role"
    [initial]="currentUsers[assignment.role]"
    [required]="data.rolesRequired"
    [errorMessage]="'A user needs to be assigned to this role'"
    (selected)="selected($event, assignment)"
  ></das-user-autocomplete>

  <mat-form-field class="input">
    <textarea
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      matInput
      type="text"
      placeholder="Design Organisation"
      [formControl]="inputOrganisation"
      [required]="true"
    >
    </textarea>
    <mat-error>
      {{ errorText() }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="input">
    <textarea
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      matInput
      type="text"
      placeholder="Designer's Name"
      [formControl]="inputDesignersName"
      [required]="true"
    >
    </textarea>
    <mat-error>
      {{ errorText() }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="input">
    <textarea
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      matInput
      type="text"
      placeholder="Job Title"
      [formControl]="inputJobTitle"
      [required]="true"
    >
    </textarea>
    <mat-error>
      {{ errorText() }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="input">
    <textarea
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      matInput
      type="text"
      placeholder="Add a comment"
      [formControl]="inputComment"
      [required]="data.commentRequired"
    >
    </textarea>
    <mat-error>
      {{ errorText() }}
    </mat-error>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="cancel()">CANCEL</button>
  <button mat-raised-button color="primary" (click)="assign()" enableDefaultFocus [disabled]="!checkFormValidity()">
    {{ actionButtonText() }}
  </button>
</mat-dialog-actions>
